import { render, staticRenderFns } from "./tabComp0.vue?vue&type=template&id=1a41c2ba&scoped=true&"
import script from "./tabComp0.vue?vue&type=script&lang=js&"
export * from "./tabComp0.vue?vue&type=script&lang=js&"
import style0 from "./tabComp0.vue?vue&type=style&index=0&id=1a41c2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41c2ba",
  null
  
)

export default component.exports